
import React from 'react';
import { LoadingScreen } from '@/components/ui/loading-screen';

export const LoadingSpinner: React.FC = () => {
  return <LoadingScreen size="xl" />;
};
